import { render } from "./BlacklistView.vue?vue&type=template&id=7ecc10a8&scoped=true"
import script from "./BlacklistView.vue?vue&type=script&lang=js"
export * from "./BlacklistView.vue?vue&type=script&lang=js"

import "./BlacklistView.vue?vue&type=style&index=0&id=7ecc10a8&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecc10a8"]])

export default __exports__